// The app's version, from frontend/package.json at build time (vite.config.ts). The versions in the
// root, frontend and scoring package.json files and backend/pom.xml are kept equal.
declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;
